import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkEmailSubjectIsAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const emailSubject = control.get('emailSubject')!.value;
	const emailReceipt = control.get('emailReceipt')!.value;

	return !!emailSubject && !emailReceipt ? { checkEmailRecipientFlag: true } : null;
};
